// Aggregate for firing off tracking events rather than polluting the code with tracking calls

// Track
// - the page view
// - the flow through each step, numbered
// - the time spent on each step
// - the time spent on the entire booking process
// - selected services
// - number of timeslots found, how long it took to find a slot, or to drop off, etc
// - proxy back to wordpress for server side tracking? no loss of data?

export function track(data: any) {
	// @ts-ignore
	const d = (window.dataLayer = window.dataLayer || []);
	d.push(data);
}
